import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const PlayerLoader = props => {
  const random = Math.random() * (1 - 0.7) + 0.7;
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="calc(100vh - 120px)"
      // viewBox="0 0 100 100"
      style={{ width: '100%' }}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColor}
      primaryopacity={1}
      secondaryospacity={0.6}
      {...props}
    >
      <rect x="7" y="5" rx="3" ry="3" width={500 * random} height="15" />
      {/* Thumbnail */}
      <rect x="7" y="50" rx="3" ry="3" width="220" height="120" />
      {/* Destino / Status da mídia */}
      <rect x="250" y="50" rx="3" ry="3" width="80" height="11" />
      <rect x="380" y="50" rx="3" ry="3" width="100" height="11" />
      <rect x="250" y="80" rx="3" ry="3" width="90" height="11" />
      <rect x="380" y="80" rx="3" ry="3" width="100" height="11" />
      <rect x="250" y="115" rx="3" ry="3" width="100" height="11" />
      <rect x="380" y="110" rx="3" ry="3" width="100" height="20" />
      <rect x="250" y="145" rx="3" ry="3" width="100" height="11" />
      <rect x="380" y="140" rx="3" ry="3" width="100" height="20" />
      {/* Avaliação */}
      <rect x="7" y="190" rx="3" ry="3" width="150" height="20" />
      <rect x="7" y="215" rx="3" ry="3" width="520" height="2" />
      <rect x="7" y="230" rx="3" ry="3" width="250" height="20" />
      {/* Sliders */}
      <rect x="7" y="270" rx="3" ry="3" width="520" height="5" />
      <circle cx="35" cy="273" r="10" />
      <rect x="7" y="310" rx="3" ry="3" width="520" height="5" />
      <circle cx="35" cy="313" r="10" />
      <circle cx="500" cy="313" r="10" />
      {/* Controle */}
      <rect x="20" y="350" rx="6" ry="6" width="500" height="70" />
      {/* Botões de avaliação */}
      <rect x="20" y="430" rx="6" ry="6" width="220" height="40" />
      <rect x="300" y="430" rx="6" ry="6" width="220" height="40" />
      <rect x="20" y="490" rx="6" ry="6" width="220" height="40" />
      <rect x="300" y="490" rx="6" ry="6" width="220" height="40" />
    </ContentLoader>
  );
};

export default PlayerLoader;
